/**
 *
 * Asynchronously loads the component for LabelTypeDetailsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const LabelTypeDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.LabelTypeDetailsPage,
);
